export const contactusTranslation = {
  en: {
    "Contact Us": "Contact Us",
    "Add Contact": "Add Contact",
    "Edit Contact": "Edit Contact",
    Delete: "Delete",
    "Search by name": "Search by name...",
    Name: "Name",
    Mobile: "Mobile",
    Email: "Email",
    Subject: "Subject",
    Message: "Message",
    "Select a subject": "Select a subject",
    "Are you sure you want to delete contact":
      "Are you sure you want to delete contact '{{contactName}}'?",
    "This action cannot be undone.": "This action cannot be undone.",
    Home: "Home",
    Settings: "Settings",
    Landing: "Landing",
    "Created At": "Created At",
    Actions: "Actions",
    "Update Contact": "Update Contact",
    "Add New Contact": "Add New Contact",
    Cancel: "Cancel",
    "Choose date range for contacts": "Choose date range for contacts",
  },
  ar: {
    "Contact Us": "اتصل بنا",
    "Add Contact": "إضافة جهة اتصال",
    "Edit Contact": "تعديل جهة الاتصال",
    Delete: "حذف",
    "Search by name": "البحث حسب الاسم...",
    Name: "الاسم",
    Mobile: "الجوال",
    Email: "البريد الإلكتروني",
    Subject: "الموضوع",
    Message: "الرسالة",
    "Select a subject": "اختر موضوعًا",
    "Are you sure you want to delete contact":
      "هل أنت متأكد أنك تريد حذف جهة الاتصال '{{contactName}}'؟",
    "This action cannot be undone.": "لا يمكن التراجع عن هذا الإجراء.",
    Home: "الصفحة الرئيسية",
    Settings: "الإعدادات",
    Landing: "الموقع التعريفي",
    "Created At": "تاريخ الإنشاء",
    Actions: "الإجراءات",
    "Update Contact": "تحديث جهة الاتصال",
    "Add New Contact": "إضافة جهة اتصال جديدة",
    Cancel: "إلغاء",
    "Choose date range for contacts": "اختر نطاق التاريخ لجهات الاتصال",
  },
};
